 
const newModel = () => {
    return {
        kehoachVonId: null,
        duanDautuId: null,
        tenDuanDautu: null,
        idKy: null,
        tenKy: null,
        namtruocChuyensang: null,
        vonphankhaiTrongnam: null,
        uocnamtruocChuyensang: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
        kehoachVonId: null,
        duanDautuId: null,
        idKy: null,
        namtruocChuyensang: null,
        vonphankhaiTrongnam: null,
        uocnamtruocChuyensang: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}
             
const fromJson = (item) => {
    return {
        kehoachVonId: item.kehoachVonId,
        duanDautuId: item.duanDautuId,
        tenDuanDautu: item.tenDuanDautu,
        idKy: item.idKy,
        tenKy: item.tenKy,
        namtruocChuyensang: item.namtruocChuyensang,
        vonphankhaiTrongnam: item.vonphankhaiTrongnam,
        uocnamtruocChuyensang: item.uocnamtruocChuyensang,
        ghiChu: item.ghiChu,
        stt: item.stt, 
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const parseModeltoFEModel = (item) => {
    return {
        kehoachVonId: item.kehoachVonId,
        duanDautuId: item.duanDautuId,
        idKy: item.idKy,
        namtruocChuyensang: item.namtruocChuyensang,
        vonphankhaiTrongnam: item.vonphankhaiTrongnam,
        uocnamtruocChuyensang: item.uocnamtruocChuyensang,
        ghiChu: item.ghiChu,
        stt: item.stt, 
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        ten: null,
        duanDautuId: null,
        idKy: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        ten: item.ten,
        duanDautuId: item.duanDautuId, 
        idKy: item.idKy,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        kehoachVonId: null,
        duanDautuId: null,
        idKy: null,
        namtruocChuyensang: null,
        vonphankhaiTrongnam: null,
        uocnamtruocChuyensang: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

export const kehoachVonModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    newPagingSearchModel,
    newSearchModel,
    fromJson,
    errors,
}


